import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoHelpCircle as HelpIcon } from 'react-icons/io5';

export default function FormatTool({ format, quality, setQuality, handleFormatChange, processImage, isProcessing, showToolTip }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-500 overflow-hidden border border-gray-100">
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-800">{t('format.title')}</h3>
          <button
            onMouseEnter={(e) => showToolTip(t('format.tooltip'), e)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <HelpIcon size={16} />
          </button>
        </div>

        <div className="space-y-6">
          <p className="text-gray-700">{t('format.chooseFormat')}</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <button
              onClick={() => handleFormatChange('png')}
              className={`p-5 border rounded-xl text-center transition-all duration-300 hover:shadow-md transform hover:-translate-y-1 ${
                format === 'png' ? 'border-blue-600 bg-blue-50 text-blue-600 shadow-md ring-1 ring-blue-200' : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="font-bold">PNG</span>
              </div>
              <h4 className="font-medium">{t('format.png.title')}</h4>
              <p className="text-xs text-gray-500 mt-1">{t('format.png.desc')}</p>
            </button>

            <button
              onClick={() => handleFormatChange('jpeg')}
              className={`p-5 border rounded-xl text-center transition-all duration-300 hover:shadow-md transform hover:-translate-y-1 ${
                format === 'jpeg' ? 'border-blue-600 bg-blue-50 text-blue-600 shadow-md ring-1 ring-blue-200' : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="font-bold">JPG</span>
              </div>
              <h4 className="font-medium">{t('format.jpeg.title')}</h4>
              <p className="text-xs text-gray-500 mt-1">{t('format.jpeg.desc')}</p>
            </button>

            <button
              onClick={() => handleFormatChange('webp')}
              className={`p-5 border rounded-xl text-center transition-all duration-300 hover:shadow-md transform hover:-translate-y-1 ${
                format === 'webp' ? 'border-blue-600 bg-blue-50 text-blue-600 shadow-md ring-1 ring-blue-200' : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="font-bold">WebP</span>
              </div>
              <h4 className="font-medium">{t('format.webp.title')}</h4>
              <p className="text-xs text-gray-500 mt-1">{t('format.webp.desc')}</p>
            </button>
          </div>

          {(format === 'jpeg' || format === 'webp') && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">{t('format.quality.label', { value: Math.round(quality * 100) })}</label>
              <input
                type="range"
                min="0.1"
                max="1.0"
                step="0.05"
                value={quality}
                onChange={(e) => setQuality(Number(e.target.value))}
                className="w-full h-2 bg-gray-100 rounded-lg appearance-none cursor-pointer accent-blue-600"
                aria-label={t('format.quality.aria')}
              />
              <div className="flex justify-between text-xs text-gray-500 mt-1">
                <span>低质量</span>
                <span>高质量</span>
              </div>
            </div>
          )}
        </div>

        <div>
          <button
            onClick={() => processImage('format')}
            disabled={isProcessing}
            className={`w-full py-3 rounded-lg transition-all duration-300 font-medium ${
              isProcessing
                ? 'bg-blue-400 text-white cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm hover:shadow transform hover:-translate-y-0.5'
            }`}
          >
            {isProcessing ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                {t('common.processing')}
              </div>
            ) : t('format.convert')
            }
          </button>
        </div>
      </div>
    </div>
  );
}